import OfficersSection from "./OfficersSection";
import TeamsSection from "./TeamsSection";
import "style.css";
import "./WelcomeMeetPage.css";

const WelcomeMeetPage = () => {
  return (
    <div className="meet-page">
      <div id="aboutUs" className="meet-about">
        <div className="meet-content">
          <h1 className="meet-heading">Our Team</h1>
          <p className="meet-intro">
            Students' Underwater Robotics Foundation is an engineering student
            organization that strives to implement the knowledge of engineering
            courses to real life projects. Mizzou SURF designs and manufactures
            marine robotic projects. SURF is a competition team with an element
            of robotic research. We are currently hard at work preparing for the
            2026 RoboSub competition at the Woollett Aquatics Center in Irvine,
            California!
          </p>
          <img
            src="/images/backgroundImages/newSURFGroupPhoto_smaller.jpg"
            alt="SURF team group"
            className="meet-group-photo"
            loading="lazy"
          />
          <div className="meet-panels">
            <OfficersSection />
            <TeamsSection />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMeetPage;
